import { PivotTableProps } from 'components/pivot-table/PivotTable'

import { KeyMapping, keyMappings } from '../common/keyMapping-relatorioGerencial'
import { VisibilidadeModeloPersonalizadoEnum } from '../components/modelo-personalizado/form/model-modeloPersonalizadoRelatorioGerencialForm'
import {
  DeficienciaRelatorioGerencialCadastroIndividualSelectFieldDocument,
  EtniaRelatorioGerencialCadastroIndividualSelectFieldDocument,
  FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument,
  IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldDocument,
  NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldDocument,
  OcupacaoRelatorioGerencialCadastroIndividualSelectFieldDocument,
  OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldDocument,
  OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument,
  RacaCorRelatorioGerencialCadastroIndividualSelectFieldDocument,
  ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldDocument,
  SimNaoNaoInformadoRelatorioGerencialSelectFieldDocument,
  SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldDocument,
  TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldDocument,
} from './../../../../graphql/hooks.generated'
import { RelatorioGerencialCadastroIndividualModel } from './model-relatorioGerencialCadastroIndividual'

const TEMPO_ATENDIMENTO_SOCIOEDUCATIVO = new Map([
  ['6 meses', 1],
  ['6 a 12 meses', 2],
  ['1 a 2 anos', 3],
  ['2 a 3 anos', 4],
  ['Não informado', 5],
])

const withFormatter = (
  keyName: string,
  queryDocument: NonNullable<KeyMapping['modelo']>['queryDocument']
): KeyMapping => ({
  keyName,
  formatter: (s: string) => s?.capitalize(),
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument,
  },
})

const simNaoKey = (keyName: string): KeyMapping => ({
  keyName,
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: SimNaoNaoInformadoRelatorioGerencialSelectFieldDocument,
  },
})

export const cadastroIndividualKeyMapping: PivotTableProps<
  RelatorioGerencialCadastroIndividualModel
>['keyMapping'] = new Map<keyof RelatorioGerencialCadastroIndividualModel, KeyMapping>([
  ['municipio', keyMappings.municipio],
  ['unidadeSaude', keyMappings.unidadeSaude],
  ['equipe', keyMappings.equipe],
  ['nomeProfissional', keyMappings.nomeProfissional],
  ['categoriaProfissional', keyMappings.categoriaProfissional],
  ['cbo', keyMappings.cbo],
  ['producoes', keyMappings.producoes],

  ['dia', keyMappings.dia],
  ['mes', keyMappings.mes],
  ['ano', keyMappings.ano],

  ['sexo', keyMappings.sexo],
  ['racaCor', withFormatter('Raça/Cor', RacaCorRelatorioGerencialCadastroIndividualSelectFieldDocument)],
  ['etnia', withFormatter('Etnia', EtniaRelatorioGerencialCadastroIndividualSelectFieldDocument)],
  [
    'nacionalidade',
    withFormatter('Nacionalidade', NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldDocument),
  ],
  [
    'escolaridade',
    withFormatter('Escolaridade', TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldDocument),
  ],
  ['faixaEtaria', keyMappings.faixaEtaria],
  [
    'orientacaoSexual',
    withFormatter('Orientação sexual', OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldDocument),
  ],
  [
    'identidadeGenero',
    withFormatter('Identidade de gênero', IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldDocument),
  ],

  [
    'situacaoTrabalho',
    withFormatter(
      'Situação no mercado de trabalho',
      SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],
  [
    'parentesco',
    withFormatter(
      'Relação de parentesco com o responsável familiar',
      TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],
  [
    'condicaoPeso',
    withFormatter(
      'Sobre seu peso, você se considera',
      TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],
  [
    'comunidadeTradicional',
    simNaoKey('É membro de Povo ou Comunidade Tradicional ou População de Campos, Floresta e Águas?'),
  ],
  ['grupoComunitario', simNaoKey('Participa de algum grupo comunitário')],
  ['planoSaude', simNaoKey('Possui plano de saúde privado')],
  ['beneficio', simNaoKey('Recebe algum benefício')],
  ['atendimentoSocioeducativo', simNaoKey('Adolescente em atendimento socioeducativo')],
  [
    'tipoAtendimentoSocioeducativo',
    withFormatter(
      'Tipo de atendimento socioeducativo',
      TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],
  [
    'tempoAtendimentoSocioeducativo',
    {
      ...withFormatter(
        'Tempo de atendimento socioeducativo',
        TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument
      ),
      ordenator: (a: string, b: string) => {
        return (TEMPO_ATENDIMENTO_SOCIOEDUCATIVO.get(a) ?? 0) > (TEMPO_ATENDIMENTO_SOCIOEDUCATIVO.get(b) ?? 0) ? 1 : -1
      },
    },
  ],

  ['possuiDeficiencia', simNaoKey('Possui alguma deficiência?')],
  ['deficiencia', withFormatter('Deficiência', DeficienciaRelatorioGerencialCadastroIndividualSelectFieldDocument)],

  ['diabetes', simNaoKey('Tem diabetes')],
  ['hipertensaoArterial', simNaoKey('Tem hipertensão arterial')],
  ['avc', simNaoKey('Teve AVC/derrame')],
  ['infarto', simNaoKey('Teve infarto')],
  ['cancer', simNaoKey('Tem ou teve câncer')],
  ['hanseniase', simNaoKey('Está com hanseníase')],
  ['tuberculose', simNaoKey('Está com tuberculose')],

  ['doencaCardiaca', simNaoKey('Teve doença cardíaca/do coração')],
  [
    'tipoDoencaCardiaca',
    withFormatter('Tipo doença cardíaca', TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldDocument),
  ],

  ['doencaRespiratoria', simNaoKey('Tem doença respiratória/no pulmão')],
  [
    'tipoDoencaRespiratoria',
    withFormatter(
      'Tipo doença respiratória',
      TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],

  ['problemaRenal', simNaoKey('Tem ou teve problemas nos rins')],
  [
    'tipoProblemaRenal',
    withFormatter('Tipo problema renal', TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldDocument),
  ],

  ['alcool', simNaoKey('Faz uso de álcool')],
  ['fumante', simNaoKey('Está fumante')],
  ['outraDroga', simNaoKey('Faz uso de outras drogas')],

  ['gestante', simNaoKey('Está gestante')],

  ['moradorRua', simNaoKey('Cidadão em situação de rua')],
  [
    'origemAlimentacao',
    withFormatter(
      'Qual é a origem da alimentação',
      OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],
  [
    'higienePessoal',
    withFormatter(
      'Itens de higiene pessoal',
      TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],
  [
    'responsavelCrianca',
    withFormatter(
      'Com quem fica a criança (menores de 9 anos)',
      ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],
  [
    'frequenciaAlimentacao',
    withFormatter(
      'Quantas vezes se alimenta ao dia',
      FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument
    ),
  ],
  [
    'tempoMoradorRua',
    withFormatter('Tempo em situação de rua', TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldDocument),
  ],
  ['temAcessoHigienePessoal', simNaoKey('Tem acesso a higiene pessoal')],
  ['referenciaFamiliar', simNaoKey('Possui referência familiar')],
  ['acompanhadoInstituicao', simNaoKey('É acompanhado por outra instituição')],
  ['visitaFamiliarFrequente', simNaoKey('Visita algum familiar com frequência')],
  ['frequentaCreche', simNaoKey('Frequenta escola ou creche')],
  ['ocupacao', withFormatter('Ocupação', OcupacaoRelatorioGerencialCadastroIndividualSelectFieldDocument)],
  ['frequentaCuidador', simNaoKey('Frequenta cuidador tradicional')],
  [
    'alimentosAcabSemDinheiro',
    simNaoKey('Nos últimos três meses, os alimentos acabaram antes que você tivesse dinheiro para comprar mais comida'),
  ],
  [
    'comeuQueTinhaDinheiroAcabou',
    simNaoKey('Nos últimos três meses, você comeu apenas alguns alimentos que ainda tinha, porque o dinheiro acabou'),
  ],
  ['acamado', simNaoKey('Está acamado')],
  ['domiciliado', simNaoKey('Está domiciliado')],
  ['pic', simNaoKey('Usa outras práticas integrativas e complementares')],
  [
    'diagnosticoProblemaSaudeMental',
    simNaoKey('Teve diagnóstico de algum problema de saúde mental por profissional de saúde'),
  ],
  ['internacao12', simNaoKey('Teve alguma internação nos últimos 12 meses')],
  ['plantasMedicinais', simNaoKey('Usa plantas medicinais')],
])
